import smoothen_strength_raw from '../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/search/smoothen_strength.svg';
export const SmoothenStrengthIcon = smoothen_strength_raw;
